import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom'; // [VP-NOTIF-BADGE 2026-05-28] detect #Notifications hash
import { getCookie } from './utils/cookies';
import { authFetch } from './utils/api'; 
import { authFetchRequest } from './utils/api';
import ExpandableSection from './expandablesection';
import Password from './controls/email/password';
import AlertDiscount from './controls/email/AlertDiscount';
import KeyValueList from './controls/email/keyvaluelist';
import Discount from './controls/frame/Discount';
import UpPrice from './controls/email/UpPrice';
import LogoUpload from './components/LogoUpload';
import { fetchUserField } from './utils/userSettings';
import { get_crm_user_id } from './CRM/SimpleCRM/crmUtils';
import { useFeatures } from './utils/FeaturesContext';
import NotificationsInbox from './components/Notifications/NotificationsInbox';
import NotificationsSend from './components/Notifications/NotificationsSend';

const Home = () => {
    const { hasFeature } = useFeatures();
    const canSendNotifications = hasFeature('SEND_NOTIFICATIONS');
    const [inboxRefreshKey, setInboxRefreshKey] = useState(0);
    // [VP-NOTIF-BADGE 2026-05-28] When the user lands here via /home#Notifications
    // (clicking the global badge), force-expand the Notifications panel.
    //
    // NOTE: deliberately NOT calling scrollIntoView. App.js applies a CSS
    // transform: scale on <body> for high-DPI compensation, and scrollIntoView
    // computes positions in that transformed coordinate space — it can leave
    // the page at a Y the browser then RESTORES across a soft refresh (F5),
    // which is why only a hard refresh (Ctrl+F5) appeared to fix the broken
    // layout. The panel is the first section here anyway, so no scroll needed.
    // Also clear the hash so a refresh doesn't re-fire this effect with the
    // restored scroll position alongside.
    const location = useLocation();
    const [forceNotifOpen, setForceNotifOpen] = useState(null);
    useEffect(() => {
      if (location.hash && /notifications/i.test(location.hash)) {
        setForceNotifOpen(true);
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    }, [location]);
    const [discountValue, setDiscountValue] = useState(0);
    const [upPriceValue, setUpPriceValue] = useState(0);
    const [ctrl_discount_enabled, set_ctrl_discount_enabled] = useState(0);
    const [enableFloatingNavMenu, setEnableFloatingNavMenu] = useState(true);
    const [enableFloatingToolbarMenu, setEnableFloatingToolbarMenu] = useState(true);
    const [navMenuStyle, setNavMenuStyle] = useState('topbar');
    const [theme, setTheme] = useState('default');


    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isDisabled, setIsDisabled] = useState(false);
    const [passwordError, setPasswordError] = useState('');
    const [submitMessage, setSubmitMessage] = useState('');
    const [crm_user_id, set_crm_user_id] = useState();
   

    useEffect(() => {
        async function init() {
            const id = await get_crm_user_id();
            set_crm_user_id(id);
        }
        init();
        fetchUserField('alertDiscount', setDiscountValue);
        fetchUserField('upPrice', setUpPriceValue);
        fetchUserField('ctrl_discount_enabled', set_ctrl_discount_enabled);
        fetchUserField('enableFloatingNavMenu', (val) => {
            console.log('enableFloatingNavMenu fetched:', val);
            setEnableFloatingNavMenu(val ?? true);
        });
        fetchUserField('enableFloatingToolbarMenu', (val) => {
            console.log('enableFloatingToolbarMenu fetched:', val);
            setEnableFloatingToolbarMenu(val ?? true);
        });
        fetchUserField('navMenuStyle', (val) => {
            setNavMenuStyle(val || 'topbar');
        });
        fetchUserField('theme', (val) => {
            const t = val || 'default';
            setTheme(t);
            document.body.setAttribute('data-theme', t);
        });

      }, []);
      
    
    // Validate password match
    useEffect(() => {
        if (confirmPassword && newPassword !== confirmPassword) {
            setPasswordError("Passwords do not match");
        } else {
            setPasswordError('');
        }
    }, [newPassword, confirmPassword]);

    // Save Password Handler
    const handleSavePassword = async () => {
        setSubmitMessage('');

        if (!currentPassword || !newPassword || !confirmPassword) {
            setPasswordError("All fields are required");
            return;
        }

        if (newPassword !== confirmPassword) {
            setPasswordError("Passwords do not match");
            return;
        }

    try {
        const result = await authFetchRequest(
            "/users/change-password",  // 🔁 This matches the Flask endpoint route
            {
                current_password: currentPassword,
                new_password: newPassword,
            },
            "POST"
        );

        // ✅ Handle success message
        setSubmitMessage(result.message || "Password saved successfully ✔️");
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
    } catch (error) {
        console.error("Password change failed:", error);
        setPasswordError(error.message || "Failed to change password. Please try again.");
    }
        // TODO: Replace with API call
        //setSubmitMessage("Password saved successfully ✔️");
    };

    const userId = getCookie('user_id') || "Guest";
    const userEmail = getCookie('user_email') || "Not provided";
    const userRole = getCookie('user_role') || "Not provided";
    const user = localStorage.getItem("user");
    const dealerCode = getCookie('dealer_code') || null;

    const handlePreferenceChange = async (fieldName, value, setter) => {
        setter(value);
        const uid = getCookie('user_id') || 0;
        try {
            await authFetchRequest(
                `/users/${uid}/field/${fieldName}`,
                { value },
                'PUT',
                { Authorization: `Bearer ${getCookie("access_token")}` }
            );
        } catch (err) {
            console.error(`Failed to update ${fieldName}:`, err);
        }
    };

    const lastLoginRaw = localStorage.getItem("last_login");
    const lastLoginDisplay = lastLoginRaw
        ? new Date(lastLoginRaw).toLocaleString()
        : 'N/A';

    const userData = [
  { key: 'User', value: user },
  { key: 'Role', value: userRole },
  { key: 'Email', value: userEmail },
  ...(dealerCode ? [{ key: 'Dealer', value: dealerCode }] : []),
  { key: 'crm_user_id', value: crm_user_id },
  { key: 'is Discount control enabled', value: ctrl_discount_enabled },
  { key: 'Last login', value: lastLoginDisplay },
];
    //<KeyValueList title="User Info" data={userData} />
    const controlMap = [
        {
            id: "KeyValueList",
            component: (
                <KeyValueList
                data={userData} 
                />
            ),
            position: [1, 1],
            status: "active",
            expandableSectionId: "Settings"
        }, 
        {
            id: "Discount",
            component: (
              <AlertDiscount
                disabled={isDisabled}
                label="Discount %"
                value={discountValue}
                onChange={(newValue) => setDiscountValue(newValue)}
              />
            ),
            position: [2, 1],
            status: "active",
            expandableSectionId: "Settings"
          },
          {
          id: "UpPrice",
          component: (
            <UpPrice
              disabled={isDisabled}
              label="UpPrice %"
              value={upPriceValue}
              onChange={(newValue) => setUpPriceValue(newValue)}
            />
          ),
          position: [3, 1],
          status: "active",
          expandableSectionId: "Settings"
        },
        {            
            id: "current-password",
            component: (
                <Password
                    id="current-password"
                    label="Current Password"
                    disabled={isDisabled}
                    value={currentPassword}
                    onChange={setCurrentPassword}
                />
            ),
            position: [1, 1],
            status: "active",
            expandableSectionId: "ChangePassword"
        },
        {
            id: "new-password",
            component: (
                <Password
                    id="new-password"
                    label="New Password"
                    disabled={isDisabled}
                    value={newPassword}
                    onChange={setNewPassword}
                />
            ),
            position: [2, 1],
            status: "active",
            expandableSectionId: "ChangePassword"
        },
        {
            id: "confirm-password",
            component: (
                <Password
                    id="confirm-password"
                    label="Re-enter New Password"
                    disabled={isDisabled}
                    value={confirmPassword}
                    onChange={setConfirmPassword}
                    error={passwordError}
                />
            ),
            position: [3, 1],
            status: "active",
            expandableSectionId: "ChangePassword"
        },
        {
            id: "logo-upload",
            component: (
            <LogoUpload />
            ),
            position: [4, 1],
            status: "active",
            expandableSectionId: "Company Settings"
        },
        {
            id: "enable-nav-menu",
            component: (
                <div className="a-container">
                    <label>Enable Navigation Menu</label>
                    <div className="pref-toggle"
                        onClick={() => handlePreferenceChange('enableFloatingNavMenu', !enableFloatingNavMenu, setEnableFloatingNavMenu)}
                    >
                        <input
                            type="checkbox"
                            checked={enableFloatingNavMenu}
                            onChange={(e) => handlePreferenceChange('enableFloatingNavMenu', e.target.checked, setEnableFloatingNavMenu)}
                            className="pref-toggle-checkbox"
                        />
                        <span className="pref-toggle-label">
                            {enableFloatingNavMenu ? 'Enabled' : 'Disabled'}
                        </span>
                    </div>
                </div>
            ),
            position: [1, 1],
            status: "active",
            expandableSectionId: "Preferences"
        },
        {
            id: "enable-toolbar-menu",
            component: (
                <div className="a-container">
                    <label>Enable Toolbar Menu</label>
                    <div className="pref-toggle"
                        onClick={() => handlePreferenceChange('enableFloatingToolbarMenu', !enableFloatingToolbarMenu, setEnableFloatingToolbarMenu)}
                    >
                        <input
                            type="checkbox"
                            checked={enableFloatingToolbarMenu}
                            onChange={(e) => handlePreferenceChange('enableFloatingToolbarMenu', e.target.checked, setEnableFloatingToolbarMenu)}
                            className="pref-toggle-checkbox"
                        />
                        <span className="pref-toggle-label">
                            {enableFloatingToolbarMenu ? 'Enabled' : 'Disabled'}
                        </span>
                    </div>
                </div>
            ),
            position: [2, 1],
            status: "active",
            expandableSectionId: "Preferences"
        },
        {
            id: "nav-menu-style",
            component: (
                <div className="a-container">
                    <label>Navigation Menu Style</label>
                    <select
                        value={navMenuStyle}
                        onChange={(e) => handlePreferenceChange('navMenuStyle', e.target.value, setNavMenuStyle)}
                        disabled={!enableFloatingNavMenu}
                    >
                        <option value="floating">Floating</option>
                        <option value="topbar">Top Bar</option>
                    </select>
                </div>
            ),
            position: [3, 1],
            status: "active",
            expandableSectionId: "Preferences"
        },
        {
            id: "theme-selector",
            component: (
                <div className="a-container">
                    <label>Theme</label>
                    <select
                        value={theme}
                        onChange={(e) => {
                            const t = e.target.value;
                            document.body.setAttribute('data-theme', t);
                            handlePreferenceChange('theme', t, setTheme);
                        }}
                    >
                        <option value="default">Default (Light)</option>
                        <option value="white">White</option>
                        <option value="dark">Sage Green</option>
                        <option value="warm">Warm</option>
                    </select>
                </div>
            ),
            position: [4, 1],
            status: "active",
            expandableSectionId: "Preferences"
        }
    ];


    return (
        <div className="content-container">
            <h3>My Account</h3>{/* [VP-NOTIF-BADGE 2026-05-28] renamed from 'Home' */}

            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '16px',
                marginBottom: '16px'
            }}>
                <div style={{ gridColumn: '1 / span 2' }}>
                    <ExpandableSection title="Notifications" panelLocation="1" forceExpanded={forceNotifOpen}>
                        <NotificationsInbox key={inboxRefreshKey} />
                    </ExpandableSection>
                </div>
                {canSendNotifications && (
                    <div style={{ gridColumn: '1 / span 2' }}>
                        <ExpandableSection title="Send Notification" panelLocation="1">
                            <NotificationsSend onSent={() => setInboxRefreshKey((k) => k + 1)} />
                        </ExpandableSection>
                    </div>
                )}
            </div>

            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '16px',
                marginTop: '16px'
            }}>
                {/* Row 1, Column 1: Settings */}
                <div style={{ gridColumn: '1', gridRow: '1' }}>
                    <ExpandableSection
                        title="Settings"
                        panelLocation="1"
                        controlMap={controlMap.filter((control) => control.expandableSectionId === "Settings")}
                    />
                </div>

                {/* Row 1-2, Column 2: Preferences (spans 2 rows) */}
                <div style={{ gridColumn: '2', gridRow: '1 / 3' }}>
                    <ExpandableSection
                        title="Preferences"
                        panelLocation="1"
                        controlMap={controlMap.filter((control) => control.expandableSectionId === "Preferences")}
                    />
                </div>

                {/* Row 2, Column 1: Change Password */}
                <div style={{ gridColumn: '1', gridRow: '2' }}>
                    <ExpandableSection
                        title="Change Password"
                        panelLocation="1"
                        controlMap={controlMap.filter((control) => control.expandableSectionId === "ChangePassword")}
                    >
                        <div className="mt-4">
                            <button
                                onClick={handleSavePassword}
                                disabled={isDisabled}
                                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                            >
                                Save Password
                            </button>

                            {submitMessage && (
                                <div className="mt-2 text-green-600">{submitMessage}</div>
                            )}

                            {passwordError && !submitMessage && (
                                <div className="mt-2 text-red-600">{passwordError}</div>
                            )}
                        </div>
                    </ExpandableSection>
                </div>

                {/* Row 2, Column 2: Company Settings (admin only) */}
                {(userRole === 'admin') && (
                    <div style={{ gridColumn: '2', gridRow: '2' }}>
                        <ExpandableSection
                            title="Company Settings"
                            panelLocation="1"
                            controlMap={controlMap.filter((control) => control.expandableSectionId === "Company Settings")}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default Home;
